import { Reducer } from 'redux';
import deepmerge from 'deepmerge';
import { ApplyConfigActionTypes, IApplyConfigState } from './types';
import { defaultApplyUniConfig } from 'apply-data';
const defaultConfig = JSON.parse(JSON.stringify(defaultApplyUniConfig ?? {}));

const initialState: IApplyConfigState = {
  applyConfig: defaultConfig,
  applyConfigLoaded: false,
  error: undefined,
};

const reducer: Reducer<IApplyConfigState> = (state = initialState, action) => {
  switch (action.type) {
    case ApplyConfigActionTypes.GET_APPLY_CONFIG:
      return {
        ...state,
        applyConfigLoaded: false,
      };
    case ApplyConfigActionTypes.GET_APPLY_CONFIG_SUCCESS: {
      let applyConfig = action.payload || {};
      const overwriteMerge = (_: [], sourceArray: []) => sourceArray;
      applyConfig = deepmerge(defaultConfig, applyConfig, {
        arrayMerge: overwriteMerge,
      });
      return {
        ...state,
        applyConfig,
        applyConfigLoaded: true,
      };
    }
    case ApplyConfigActionTypes.GET_APPLY_CONFIG_FAILURE: {
      const error = action.payload || {};
      return {
        ...state,
        applyConfigLoaded: false,
        error,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as applyConfigReducer };
